"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import UiGrid from "@/components/grid/UiGrid.vue";
import API from "@ym-framework/api-utils";
let MonitorLogDetail = class extends Vue {
  constructor() {
    super(...arguments);
    this.id = "";
    this.pageLoading = false;
    // 响应数据
    this.responsedata = {
      id: "",
      account: "",
      shopName: "",
      startAndEndTime: "",
      duration: "",
      logs: []
    };
    // 筛选相关数据
    this.dateRange = ["", ""];
    this.warnEvent = "ALL";
    this.operationBehavior = "ALL";
    this.searchUrl = "";
    // 列表展开状态
    this.expandedItems = [0];
    // 默认展开第一个
    // 事件列表
    this.eventList = [];
    // 选中的操作
    this.selectedOperation = "";
    this.selectedScreenshot = "";
    // 播放控制相关
    this.isPlaying = false;
    this.playbackProgress = 0;
    this.playbackSpeed = 1;
    this.autoPlay = true;
    // 新增：所有有截图的日志列表（扁平化）
    this.allScreenshots = [];
    this.currentScreenshotIndex = 0;
    this.autoPlayTimer = null;
    // 新增：所有操作项的统一列表（用于时间线显示和播放控制）
    this.allOperations = [];
    // 全屏查看相关
    this.isFullscreen = false;
    this.fullscreenScale = 1;
    // 缩放比例
    this.fullscreenPosition = { x: 0, y: 0 };
    // 图片位置
    this.isDragging = false;
    // 是否正在拖拽
    this.dragStart = { x: 0, y: 0 };
    // 拖拽起始位置
    this.dragOffset = { x: 0, y: 0 };
  }
  // 拖拽偏移量
  mounted() {
    return __async(this, null, function* () {
      if (this.$route.query && this.$route.query.id) {
        this.id = this.$route.query.id;
        yield this.getEventList();
        yield this.getMonitorLogDetail();
      }
    });
  }
  // 获取全部事件列表
  getEventList() {
    return __async(this, null, function* () {
      try {
        const eventResponse = yield API.get(
          `api://base.auth/api/v1/monitor/alarm/internal-events-list`
        );
        this.eventList = eventResponse.data.datas;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  checkOperationBehavior(operation) {
    if (operation === "LEFT_MOUSE_CLICK") {
      return this.$t("monitor_log.operation_click");
    }
    if (operation === "RIGHT_MOUSE_CLICK") {
      return this.$t("monitor_log.operation_right_click");
    }
    if (operation === "UPLOAD") {
      return this.$t("monitor_log.operation_upload");
    }
    if (operation === "DOWNLOAD") {
      return this.$t("monitor_log.operation_download");
    }
    if (operation === "VISIT_WEBPAGE") {
      return this.$t("monitor_log.operation_visit_webpage");
    }
    if (operation === "COPY") {
      return this.$t("monitor_log.operation_copy");
    }
    if (operation === "PRINT") {
      return this.$t("monitor_log.operation_print");
    }
    if (operation === "DEVELOPER_MODE") {
      return this.$t("monitor_log.operation_developer_mode");
    }
    if (operation === "KEYBOARD_INPUT") {
      return this.$t("monitor_log.operation_keyboard_input");
    }
  }
  getMonitorLogDetail() {
    return __async(this, null, function* () {
      this.pageLoading = true;
      try {
        const response = yield API.get(
          `api://base.auth/api/v1/monitor-log/${this.id}`
        );
        this.responsedata = response.data;
        this.processScreenshots();
        this.selectFirstScreenshot();
        if (this.autoPlay) {
          this.isPlaying = true;
          this.startAutoPlay();
        }
      } catch (error) {
        if (error && typeof error === "object" && "response" in error) {
          const err = error;
          this.$message.error(err.response.data.errors.datas[0].message);
        } else {
          this.$message.error("\u83B7\u53D6\u76D1\u63A7\u65E5\u5FD7\u8BE6\u60C5\u5931\u8D25");
        }
      } finally {
        this.pageLoading = false;
      }
    });
  }
  changeAutoPlay() {
    return __async(this, null, function* () {
      this.autoPlay = !this.autoPlay;
      if (this.autoPlay) {
        this.isPlaying = true;
        this.startAutoPlay();
      } else {
        this.stopAutoPlay();
      }
    });
  }
  // 返回上一页
  goBack() {
    this.$router.push("/midsafety?tab=monitor_log");
  }
  // 导出功能
  handleExport(command) {
  }
  // 查询功能
  handleQuery() {
    return __async(this, null, function* () {
      try {
        let searchParams = {};
        if (this.dateRange[0] && this.dateRange[1]) {
          searchParams.startTime = Math.floor(Date.parse(this.dateRange[0]) / 1e3);
          searchParams.endTime = Math.floor(Date.parse(this.dateRange[1]) / 1e3);
        }
        if (this.warnEvent && this.warnEvent !== "ALL") {
          searchParams.warnEvent = this.warnEvent;
        }
        if (this.operationBehavior && this.operationBehavior !== "ALL") {
          searchParams.operationBehavior = this.operationBehavior;
        }
        if (this.searchUrl && this.searchUrl !== "") {
          searchParams.web = this.searchUrl;
        }
        const response = yield API.get(`api://base.auth/api/v1/monitor-log/${this.id}`, {
          params: searchParams
        });
        this.responsedata = response.data;
        this.selectedScreenshot = "";
        this.processScreenshots();
        this.selectFirstScreenshot();
        if (this.autoPlay) {
          this.isPlaying = true;
          this.startAutoPlay();
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  // 重置功能
  handleReset() {
    return __async(this, null, function* () {
      try {
        this.dateRange = ["", ""];
        this.warnEvent = "ALL";
        this.operationBehavior = "ALL";
        this.searchUrl = "";
        const response = yield API.get(`api://base.auth/api/v1/monitor-log/${this.id}`);
        this.responsedata = response.data;
        this.selectedScreenshot = "";
        this.processScreenshots();
        this.selectFirstScreenshot();
        if (this.autoPlay) {
          this.isPlaying = true;
          this.startAutoPlay();
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  // 处理截图数据：提取所有有截图的日志
  processScreenshots() {
    this.allScreenshots = [];
    this.allOperations = [];
    this.responsedata.logs.forEach((log, logIndex) => {
      log.logs.forEach((operation, opIndex) => {
        this.allOperations.push({
          logIndex,
          opIndex,
          operation,
          webName: log.webName,
          webUrl: log.webUrl,
          startAndEndTime: log.startAndEndTime
        });
        if (operation.screenshotUrl) {
          this.allScreenshots.push({
            logIndex,
            opIndex,
            operation,
            webName: log.webName,
            webUrl: log.webUrl,
            startAndEndTime: log.startAndEndTime
          });
        }
      });
    });
  }
  // 选择第一张截图
  selectFirstScreenshot() {
    if (this.allOperations.length > 0) {
      const firstOperation = this.allOperations[0];
      this.selectedOperation = `${firstOperation.logIndex}-${firstOperation.opIndex}`;
      this.selectedScreenshot = firstOperation.operation.screenshotUrl || "";
      this.updatePlaybackProgress();
      if (firstOperation.operation.screenshotUrl) {
        const screenshotIndex = this.allScreenshots.findIndex(
          (item) => item.logIndex === firstOperation.logIndex && item.opIndex === firstOperation.opIndex
        );
        if (screenshotIndex !== -1) {
          this.currentScreenshotIndex = screenshotIndex;
        }
      }
    }
  }
  // 切换展开/折叠
  toggleExpand(index) {
    const expandedIndex = this.expandedItems.indexOf(index);
    if (expandedIndex > -1) {
      this.expandedItems.splice(expandedIndex, 1);
    } else {
      this.expandedItems.push(index);
    }
  }
  // 获取操作项在全局操作列表中的索引
  getGlobalOperationIndex(logIndex, opIndex) {
    return this.allOperations.findIndex(
      (item) => item.logIndex === logIndex && item.opIndex === opIndex
    );
  }
  // 选择操作
  selectOperation(logIndex, opIndex, operation) {
    this.selectedOperation = `${logIndex}-${opIndex}`;
    this.selectedScreenshot = operation.screenshotUrl || "";
    const screenshotIndex = this.allScreenshots.findIndex(
      (item) => item.logIndex === logIndex && item.opIndex === opIndex
    );
    if (screenshotIndex !== -1) {
      this.currentScreenshotIndex = screenshotIndex;
    }
    this.updatePlaybackProgress();
  }
  // 更新播放进度
  updatePlaybackProgress() {
    if (this.allOperations.length > 0) {
      const currentOperationIndex = this.allOperations.findIndex(
        (item) => item.logIndex === parseInt(this.selectedOperation.split("-")[0]) && item.opIndex === parseInt(this.selectedOperation.split("-")[1])
      );
      if (currentOperationIndex !== -1) {
        this.playbackProgress = Math.round(
          currentOperationIndex / (this.allOperations.length - 1) * 100
        );
      } else {
        this.playbackProgress = 0;
      }
    } else {
      this.playbackProgress = 0;
    }
  }
  // 播放控制方法
  togglePlay() {
    this.isPlaying = !this.isPlaying;
    if (this.isPlaying) {
      this.startAutoPlay();
    } else {
      this.stopAutoPlay();
    }
  }
  // 开始自动播放
  startAutoPlay() {
    if (this.autoPlayTimer) {
      clearInterval(this.autoPlayTimer);
    }
    const interval = 2e3 / this.playbackSpeed;
    this.autoPlayTimer = window.setInterval(() => {
      this.nextFrame();
    }, interval);
  }
  // 停止自动播放
  stopAutoPlay() {
    if (this.autoPlayTimer) {
      window.clearInterval(this.autoPlayTimer);
      this.autoPlayTimer = null;
    }
  }
  // 上一帧
  previousFrame() {
    const currentOperationIndex = this.allOperations.findIndex(
      (item) => item.logIndex === parseInt(this.selectedOperation.split("-")[0]) && item.opIndex === parseInt(this.selectedOperation.split("-")[1])
    );
    if (currentOperationIndex > 0) {
      const prevOperation = this.allOperations[currentOperationIndex - 1];
      this.selectOperation(
        prevOperation.logIndex,
        prevOperation.opIndex,
        prevOperation.operation
      );
    }
  }
  // 下一帧
  nextFrame() {
    const currentOperationIndex = this.allOperations.findIndex(
      (item) => item.logIndex === parseInt(this.selectedOperation.split("-")[0]) && item.opIndex === parseInt(this.selectedOperation.split("-")[1])
    );
    if (currentOperationIndex < this.allOperations.length - 1) {
      const nextOperation = this.allOperations[currentOperationIndex + 1];
      this.selectOperation(
        nextOperation.logIndex,
        nextOperation.opIndex,
        nextOperation.operation
      );
    } else {
      this.isPlaying = false;
      this.stopAutoPlay();
    }
  }
  // 根据索引选择截图
  selectScreenshotByIndex(index) {
    if (index >= 0 && index < this.allScreenshots.length) {
      const screenshot = this.allScreenshots[index];
      this.selectedOperation = `${screenshot.logIndex}-${screenshot.opIndex}`;
      this.selectedScreenshot = screenshot.operation.screenshotUrl;
      this.updatePlaybackProgress();
      this.scrollToOperation(index);
    }
  }
  // 格式化进度条 tooltip，显示对应的时间点
  formatProgressTooltip(value) {
    if (this.allOperations.length === 0) {
      return "";
    }
    const index = Math.round(value / 100 * (this.allOperations.length - 1));
    const operation = this.allOperations[index];
    if (operation && operation.operation && operation.operation.createdTime) {
      return operation.operation.createdTime;
    }
    return "";
  }
  // 进度条变化处理
  onProgressChange(value) {
    if (this.allOperations.length > 0) {
      const index = Math.round(value / 100 * (this.allOperations.length - 1));
      const operation = this.allOperations[index];
      this.selectOperation(
        operation.logIndex,
        operation.opIndex,
        operation.operation
      );
      this.scrollToOperation(index);
    }
  }
  // 滚动到指定的操作项
  scrollToOperation(operationIndex) {
    if (operationIndex >= 0 && operationIndex < this.allOperations.length) {
      const operation = this.allOperations[operationIndex];
      const operationKey = `operation-${operation.logIndex}-${operation.opIndex}`;
      if (!this.expandedItems.includes(operation.logIndex)) {
        this.expandedItems.push(operation.logIndex);
      }
      setTimeout(() => {
        const operationElement = this.$refs[operationKey];
        let element = null;
        if (Array.isArray(operationElement)) {
          element = operationElement[0];
        } else if (operationElement) {
          element = operationElement;
        }
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest"
          });
        } else {
          const selector = `[data-operation-key="${operationKey}"]`;
          const fallbackElement = document.querySelector(
            selector
          );
          if (fallbackElement) {
            fallbackElement.scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "nearest"
            });
          }
        }
      }, 100);
    }
  }
  // 下载文件
  downloadFile(url, filename) {
    window.open(url, "_blank");
  }
  setPlaybackSpeed(speed) {
    this.playbackSpeed = speed;
    if (this.isPlaying) {
      this.startAutoPlay();
    }
  }
  toggleFullscreen() {
    if (!this.selectedScreenshot) {
      this.$message.warning("\u6CA1\u6709\u53EF\u663E\u793A\u7684\u56FE\u7247");
      return;
    }
    this.isFullscreen = true;
    this.fullscreenScale = 1;
    this.fullscreenPosition = { x: 0, y: 0 };
    this.dragOffset = { x: 0, y: 0 };
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", this.handleEscKey);
  }
  closeFullscreen() {
    this.isFullscreen = false;
    document.body.style.overflow = "";
    document.removeEventListener("keydown", this.handleEscKey);
  }
  handleEscKey(event) {
    if (event.key === "Escape" && this.isFullscreen) {
      this.closeFullscreen();
    }
  }
  // 鼠标滚轮缩放
  handleWheel(event) {
    event.preventDefault();
    const delta = event.deltaY > 0 ? -0.1 : 0.1;
    const oldScale = this.fullscreenScale;
    const newScale = Math.max(0.5, Math.min(5, this.fullscreenScale + delta));
    const rect = event.currentTarget.getBoundingClientRect();
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    const mouseX = event.clientX - rect.left;
    const mouseY = event.clientY - rect.top;
    const offsetX = mouseX - centerX - this.fullscreenPosition.x;
    const offsetY = mouseY - centerY - this.fullscreenPosition.y;
    const scaleRatio = newScale / oldScale;
    this.fullscreenPosition.x = mouseX - centerX - offsetX * scaleRatio;
    this.fullscreenPosition.y = mouseY - centerY - offsetY * scaleRatio;
    this.fullscreenScale = newScale;
  }
  // 鼠标按下开始拖拽
  handleMouseDown(event) {
    if (this.fullscreenScale > 1 && event.target instanceof HTMLImageElement) {
      this.isDragging = true;
      this.dragStart = { x: event.clientX, y: event.clientY };
      event.preventDefault();
    }
  }
  // 鼠标移动拖拽
  handleMouseMove(event) {
    if (this.isDragging) {
      const deltaX = event.clientX - this.dragStart.x;
      const deltaY = event.clientY - this.dragStart.y;
      this.dragOffset = { x: deltaX, y: deltaY };
    }
  }
  // 鼠标释放结束拖拽
  handleMouseUp() {
    if (this.isDragging) {
      this.fullscreenPosition.x += this.dragOffset.x;
      this.fullscreenPosition.y += this.dragOffset.y;
      this.dragOffset = { x: 0, y: 0 };
      this.isDragging = false;
    }
  }
  // 计算全屏图片样式
  get fullscreenImageStyle() {
    const transition = this.isDragging ? "none" : "transform 0.1s ease-out";
    return {
      transform: `translate(${this.fullscreenPosition.x + this.dragOffset.x}px, ${this.fullscreenPosition.y + this.dragOffset.y}px) scale(${this.fullscreenScale})`,
      cursor: this.fullscreenScale > 1 ? this.isDragging ? "grabbing" : "grab" : "default",
      transition
    };
  }
  // 组件销毁时清理定时器和事件监听
  beforeDestroy() {
    this.stopAutoPlay();
    document.removeEventListener("keydown", this.handleEscKey);
    document.body.style.overflow = "";
  }
};
MonitorLogDetail = __decorateClass([
  Component({
    components: {
      UiGrid
    }
  })
], MonitorLogDetail);
export {
  MonitorLogDetail as default
};
